// extracted by mini-css-extract-plugin
module.exports = {"alternativeAudience":"AlternativeAudience_alternativeAudience__fUHXQ","text":"AlternativeAudience_text__zABjX"};